import { StorageKeys } from '../config/constants';

export interface StoredUser {
  id: number;
  username: string;
  role: string;
  cid?: number;
}

// Helper to get the appropriate storage based on "remember me" preference
const getStorage = (): Storage => {
  const rememberMe = localStorage.getItem(StorageKeys.RememberMe) === 'true';
  return rememberMe ? localStorage : sessionStorage;
};

export const StorageService = {
  getToken(): string | null {
    // Check both storages - localStorage takes precedence
    return localStorage.getItem(StorageKeys.Token) || sessionStorage.getItem(StorageKeys.Token);
  },

  setToken(token: string): void {
    getStorage().setItem(StorageKeys.Token, token);
  },

  getRefreshToken(): string | null {
    return localStorage.getItem(StorageKeys.RefreshToken) || sessionStorage.getItem(StorageKeys.RefreshToken);
  },

  setRefreshToken(token: string): void {
    getStorage().setItem(StorageKeys.RefreshToken, token);
  },

  getUser(): StoredUser | null {
    const data = localStorage.getItem(StorageKeys.User) || sessionStorage.getItem(StorageKeys.User);
    if (!data) return null;
    try {
      return JSON.parse(data);
    } catch {
      return null;
    }
  },

  setUser(user: StoredUser): void {
    getStorage().setItem(StorageKeys.User, JSON.stringify(user));
  },

  setRememberMe(remember: boolean): void {
    if (remember) {
      localStorage.setItem(StorageKeys.RememberMe, 'true');
    } else {
      localStorage.removeItem(StorageKeys.RememberMe);
    }
  },

  getRememberMe(): boolean {
    return localStorage.getItem(StorageKeys.RememberMe) === 'true';
  },

  clearAuth(): void {
    // Clear from both storages
    localStorage.removeItem(StorageKeys.Token);
    localStorage.removeItem(StorageKeys.RefreshToken);
    localStorage.removeItem(StorageKeys.User);
    sessionStorage.removeItem(StorageKeys.Token);
    sessionStorage.removeItem(StorageKeys.RefreshToken);
    sessionStorage.removeItem(StorageKeys.User);
  },

  clearAll(): void {
    Object.values(StorageKeys).forEach((key) => {
      localStorage.removeItem(key);
      sessionStorage.removeItem(key);
    });
  },
};
